import { Router } from 'aurelia-router';
import { autoinject } from 'aurelia-framework';
import { IdentityHelpers } from '@identity/helpers';

@autoinject
export class FooterPublic {

  private router: Router;
  private identity: IdentityHelpers;

  currentYear() {
    return new Date().getFullYear();
  }

  constructor(router: Router, identity: IdentityHelpers) {
    this.router = router;
    this.identity = identity;
  }
}
